import { getCPDataWithParams } from './index'

/**
 * Fetches the current communication quota for a clinic brand
 * @param {string} clinicBrandId - The clinic brand ID
 * @returns {Promise<Object>} The communication quota data
 */
export async function getClinicBrandCommsQuota(clinicBrandId) {
  try {
    const response = await getCPDataWithParams(
      '/api/secure/clinic-admin/clinic-brand-comms-quota/current',
      { clinicBrandId }
    )
    
    if (response?.status === 200 && response?.data) {
      // Check if response follows CommonResponse format
      if (response.data.code === 2000 && response.data.data) {
        // The API returns data with kebab-case key: "clinic-brand-comms-quota"
        const quotaData = response.data.data['clinic-brand-comms-quota'] || 
                         response.data.data.clinicBrandCommsQuota ||
                         response.data.data
        
        // If quotaData exists and has the expected structure, return it
        if (quotaData && (quotaData.waCredits !== undefined || quotaData.outcallCredits !== undefined)) {
          return quotaData
        }
      }
      
      // Fallback: if data structure is different, try to find quota object
      if (response.data.waCredits !== undefined || response.data.outcallCredits !== undefined) {
        return response.data
      }
      
      throw new Error('Invalid response structure from quota API')
    }
    
    throw new Error(response?.data?.message || 'Failed to fetch communication quota')
  } catch (error) {
    console.error('Error fetching communication quota:', error)
    throw error
  }
}

